import styled from 'styled-components'

export const ContentModal = styled.div`
  width: 100%;
  min-width: 288px;
  max-width: 600px;
  display: flex;
  flex-direction: column;

  @media (min-width: 480px) {
    min-width: 432px;
  }
`

export const WrapperText = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #d4d4d4;
  margin: 0;
`

export const DotDivider = styled.hr`
  border: none;
  border-top: 1px dashed #d4d4d4;
  gap: 20px;
  margin: 0;
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px 0;
`

export const TwoFields = styled.div`
  display: flex;
  justify-content: space-between;
`

export const FieldPayment = styled.div`
  margin: 0px 0px 8px 0px;
`

export const ButtonsRow = styled.div`
  display: flex;
  gap: 24px;
  margin: 12px 0 0 0;

  @media (max-width: 480px) {
    margin: 12px 0;
  }

  > * {
    flex: 1;
    width: 100%;
    min-width: 0;
    white-space: nowrap;
  }
`
